import React from "react";
import "./toolbar.css";

export default function TableToolbar({
  searchTerm,
  onSearchChange,
  filterDefs = [],
  filters = {},
  onFilterChange,
  searchPlaceholder = "Search...", // <— add this default
}) {
  return (
    <div className="sa-toolbar">
      {/* Search (no icon, manager wants 'Search venues…') */}
      <input
        className="sa-input"
        type="text"
        placeholder={searchPlaceholder}
        value={searchTerm}
        onChange={(e) => onSearchChange?.(e.target.value)}
      />

      {/* Compact pill selects with placeholder labels inside the control */}
      <div className="sa-filters">
        {filterDefs.map((fd) => {
          const value = filters[fd.id];
          // Show placeholder label (e.g., "Status") when logical value is 'all'
          const controlValue = value === "all" ? "" : value;

          return (
            <select
              key={fd.id}
              className="sa-select"
              value={controlValue}
              onChange={(e) => {
                const v = e.target.value || "all";
                onFilterChange?.(fd.id, v);
              }}
            >
              {/* Placeholder that shows the field name in the control itself */}
              <option value="" disabled>
                {fd.label}
              </option>

              {fd.options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          );
        })}
      </div>
    </div>
  );
}
